export default {
  CHROME: 'CHROME',
  FIREFOX: 'FIREFOX',
  DESKTOP_SAFARI: 'DESKTOP_SAFARI',
  IE: 'IE',
  IOS: 'IOS',
  ETC: 'ETC',
};
